<template>
  <div class="filter__wrap">
    <slot />
  </div>
</template>
<script></script>
<style lang="scss" scoped>
.filter__wrap {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
  font-weight: 500;
}
</style>
